import { useContext } from 'react';
import { Toast } from '@components/toasts/toast';
import { ToastContext } from '@components/toasts/toast-context';

export default function ToastList() {
  const toastState = useContext(ToastContext);
  if (!toastState) {
    throw new Error('ToastList must be used within a ToastContext');
  }
  const { toasts } = toastState;

  return (
    <div className="fixed top-20 z-20 w-full pointer-events-none">
      {toasts.map((toast) => (
        <div className="flex justify-end my-2 px-4 w-full" key={toast.id}>
          {
            <Toast
              toastType={toast.toastType}
              title={toast.title}
              subTitle={toast.subTitle}
              onClose={toast.onClose}
            />
          }
        </div>
      ))}
    </div>
  );
}
